import React, { useMemo } from 'react';
import NlimsDataTable from '../../shared/NlimsDataTable/NlimsDataTable';
import { zoonoticAMRRecords } from '../mockData/AnimalHealthData';

const RESOLUTION_STYLE = {
  'Active':           'background:#dcfce7;color:#15803d;border:1px solid #86efac;',
  'Under Monitoring': 'background:#fff7ed;color:#c2410c;border:1px solid #fed7aa;',
  'Resolved':         'background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;',
};
function resolutionHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const s = RESOLUTION_STYLE[data] || 'background:#f3f4f6;color:#6b7280;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${s}">${data || '—'}</span>`;
}

const COLUMNS = [
  { title: 'Disease Event',         data: 'diseaseEvent',       sortable: true },
  { title: 'Flag Type',             data: 'flagType',           sortable: true },
  { title: 'Flag Date',             data: 'flagDate',           sortable: true },
  { title: 'Human Cases Reported',  data: 'humanCasesReported', sortable: true },
  { title: 'AMR Drug Class',        data: 'amrDrugClass',       sortable: true },
  { title: 'AMR Pathogen',          data: 'amrPathogen',        sortable: true },
  { title: 'Response Protocol',     data: 'responseProtocol',   sortable: true },
  { title: 'Resolution Status',     data: 'resolutionStatus',   sortable: true, render: resolutionHtml },
];

export default function ZoonoticAMRFlagsTab({ searchQuery = '' }) {
  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return zoonoticAMRRecords;
    return zoonoticAMRRecords.filter(r =>
      Object.values(r).some(v =>
        (typeof v === 'string' && v.toLowerCase().includes(q)) ||
        (typeof v === 'number' && String(v).includes(q))
      )
    );
  }, [searchQuery]);

  return (
    <NlimsDataTable
      tableId="zoonotic-amr-table"
      columns={COLUMNS}
      data={filtered}
      serverSide={false}
      hideSearch
      pageLength={10}
      enableRowSelection
    />
  );
}
